<template>
  <v-row>

    <transition name="fade-up" mode="out-in" appear>
      <v-col v-if="loading" class="text-center" key="loader">
        <v-progress-circular
          :size="40"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-col>
      <v-col v-else cols="12" key="billingSuccess">
        <div class="title mb-2 text-center">Thanks!</div>
        <div v-if="error" class="mt-4 text-center  success--text title">{{ error }}</div>
        <div v-else class="mt-4 text-center success--text title">Your subscription is now active. Please use the menu on the left to get started.</div>
      </v-col>
    </transition>
  </v-row>
</template>

<script>
export default {
  name: 'BillingSuccess',
  data () {
    return {
      loading: true,
      error: null
    }
  },
  mounted() {
    if(!this.successId) {
      this.$router.replace({name: 'billing'})
    } else {
      this.getDataFromApi()
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    successId () {
      return this.$route.query.id
    }
  },
  methods: {
    getDataFromApi() {
      this.loading = true

      this.$http.post(`users/${this.user.id}/success-session`, { id: this.successId }, { withCredentials: true })
        .then(response => {
          if(response.data.status == 'ACTIVE') {
            this.$store.dispatch('checkForUpdates', true)
          } else {
            this.error = 'Your account is being activated. Please check back in 5 minutes.'
          }
        })
        .catch(() => {
          this.error = 'Your account is being activated. Please check back in 5 minutes.'
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>